var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"checkWrapper"},[_c('b-icon',{staticClass:"checkIcon",attrs:{"icon":"x"}})],1),_c('h1',[_vm._v("Fehler")]),_c('p',[_vm._v(_vm._s(_vm.errorMsg || 'Es ist ein Fehler aufgetreten'))]),_c('router-link',{attrs:{"to":"/"}},[_c('small',[_c('b-icon',{attrs:{"icon":"chevron-left"}}),_vm._v(" Zurück zum Start ")],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }